var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.20801 1.66675C4.17988 1.66675 3.33301 2.51362 3.33301 3.54175V16.4584C3.33301 17.4865 4.17988 18.3334 5.20801 18.3334H14.7913C15.8195 18.3334 16.6663 17.4865 16.6663 16.4584V7.70841C16.6663 7.54267 16.6004 7.38371 16.4832 7.26652L16.4767 7.26001L11.0666 1.84985C10.9494 1.73264 10.7904 1.66678 10.6247 1.66675H5.20801ZM5.20801 2.91675H9.99967V6.45841C9.99967 7.48654 10.8465 8.33341 11.8747 8.33341H15.4163V16.4584C15.4163 16.8111 15.144 17.0834 14.7913 17.0834H5.20801C4.8553 17.0834 4.58301 16.8111 4.58301 16.4584V3.54175C4.58301 3.18904 4.8553 2.91675 5.20801 2.91675ZM11.2497 3.80054L14.5326 7.08341H11.8747C11.522 7.08341 11.2497 6.81112 11.2497 6.45841V3.80054Z",
    fill: "#FFBE1D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.dd4a8b02dabb3b8e165568612ed82e8e.svg";
export { ForwardRef as ReactComponent };